define('modules/emblue/view',['require','exports','module','views/BaseView','env','ldsh!./template'],function (require, exports, module) {
  "use strict";

  var BaseView = require("views/BaseView"),
    Config = require("env");

  var Layout = BaseView.extend({
    template: require("ldsh!./template"),
    status: false,
    returnUrl: false,
    events: {
      "click #goToBack": "goToBack",
      "click #retryAction": "retryAction",
    },

    beforeRender: function () {},

    initialize: function (options) {
      this.status = this.options.status;
    },

    serialize: function () {
      return { tab: this.options.tab, status: this.status };
    },
    goToBack: function (event) {
      event.preventDefault();
      event.stopPropagation();
      window.location = this.returnUrl;
    },
    retryAction: function (event) {
      event.preventDefault();
      event.stopPropagation();
      console.log("retryAction");
      window.location.reload;
    },
  });

  module.exports = Layout;
});

